import React from 'react';
import { T, fonts, layout } from '../../theme/tokens';

export function OptionList({
  options,
  onPick,
  value,
  getId = (o) => o.id,
  getText = (o) => o.text || o.label,
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {options.map((o) => {
        const active = value === getId(o);
        return (
          <button
            key={getId(o)}
            onClick={() => onPick(getId(o))}
            style={{
              textAlign: "left",
              padding: "15px 18px",
              borderRadius: layout.radius,
              cursor: "pointer",
              background: active
                ? `color-mix(in srgb, ${T.accent} 6%, ${T.surface})`
                : T.surface,
              border: `2px solid ${active ? T.accent : T.borderLight}`,
              color: T.textDark,
              fontSize: 15,
              fontFamily: fonts.body,
              fontWeight: active ? 500 : 400,
              lineHeight: 1.5,
              transition: "background .14s, border-color .14s",
            }}
            onMouseEnter={(e) => {
              if (!active) e.currentTarget.style.background = T.creamDark;
            }}
            onMouseLeave={(e) => {
              if (!active) e.currentTarget.style.background = T.surface;
            }}
          >
            {getText(o)}
          </button>
        );
      })}
    </div>
  );
}
